module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/medipremium-1.webp?c2794791";